<template>
  <div class="PackSelect-container">
    <el-select
      ref="select"
      v-model="value"
      placeholder="请选择包装，可输入关键字搜索"
      filterable
      clearable
      prefix-icon="el-icon-search"
      :filter-method="searchOrder"
      :disabled="disabled"
      :loading="loading"
      :style="tcfstyle"
      @clear="clearSelect"
    >
      <el-option :value="value" :label="changeLabel" style="height: auto;padding: 0;">
        <el-table
          :data="tableData"
          :show-header="false"
          :row-style="{cursor: 'pointer'}"
          style="width: 100%"
          @row-click="openDetails"
        >
          <el-table-column
            label="订单号"
            width="180"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span style="color:#99a9bf">订单号：</span>
              <span> {{ scope.row.ordernum }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="生产单号"
            width="90"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span style="font-weight: 500;color:#409EFF">{{ scope.row.produnum }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="标签号"
            width="220"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span style="color:#99a9bf">标签号：</span>
              <span>{{ scope.row.packnum }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="包号"
            width="150"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span style="color:#99a9bf">包号：</span>
              <span>{{ scope.row.xuhao }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="打包人"
            width="90"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{ scope.row.username }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="打包时间"
            min-width="170"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{ scope.row.time }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-option>
      <el-pagination
        v-if="total>0"
        style="padding:10px"
        background
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </el-select>
  </div>
</template>

<script>
import { getErpOrderPackSelect } from '@/api/erp'
import { getUser } from '@/utils/auth'

export default {
  name: 'PackSelect',
  props: {
    imark: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tcfstyle: {
      type: String,
      default: 'width: 100%'
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 5,
      total: 0,
      filterText: '',
      filterTimer: null,
      value: '',
      changeLabel: ''
    }
  },
  computed: {
    user: getUser
  },
  // created() {
  //   this.getData()
  // },
  methods: {
    getData() {
      this.loading = true
      const data = {
        groupid: this.user.dGroupid,
        imark: this.imark,
        content: this.filterText,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid,
        role: this.user.role
      }
      getErpOrderPackSelect(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    clearSelect() {
      this.filterText = ''
      this.value = ''
      this.changeLabel = ''
      this.$emit('input', this.value)
    },
    searchOrder(val) {
      this.filterText = val
      // 2024-9-27 修改部分：输入过程中不进行接口请求
      if (!this.filterText) return
      if (this.filterTimer) clearTimeout(this.filterTimer)
      this.filterTimer = setTimeout(() => {
        this.getData()
      }, 1000)
    },
    openDetails(data) {
      this.value = data.packid
      this.changeLabel = data.ordernum + ' / ' + data.produnum + ' / ' + data.packnum
      this.$emit('input', this.value)
      this.$emit('setOrder', data)
      this.$refs.select.blur()
    }
  }
}
</script>
<style lang="scss" scoped>
.PackSelect-container{
  .el-table::before{
    height: 0!important;
  }
  .el-pagination{
    margin-top: 20px;
  }
}
</style>
